import { InfoBox } from "./InfoBox";




export class ErrorBox extends InfoBox
{
    constructor(title: string, content: string)
    {
        super(title, content, "#ff7795");
    }
}
